<article class="flex w-full gap-3 p-4">
  <div class="relative flex size-12 items-center justify-center rounded-full">
    <app-avatar variant="icon" icon="mingcute:rocket-fill"></app-avatar>
    <span class="absolute bottom-0 right-0 size-3 rounded-full bg-primary ring-2 ring-white" aria-hidden="true"></span>
  </div>

  <div class="flex flex-1 flex-col gap-3">
    <div class="flex flex-col gap-1 text-sm tracking-normal">
      <h3 class="text-sm font-medium text-neutral-grey-950">
        {{ notification().subject }}
      </h3>
      <p class="text-sm font-normal text-neutral-grey-800">
        {{ notification().body }}
      </p>
    </div>

    <div class="flex flex-row gap-2 items-center justify-between">
      <p class="text-xs font-normal text-neutral-grey-700">
        {{ notification().createdAt | timeAgo }}
      </p>
      @if (resolvedContext()?.userId != null) {
        @let button = routeBuilder.build(notification().notificationType, resolvedContext());
        <a class="btn-hyperlink w-fit justify-start" [routerLink]="button.link" [queryParams]="button.queryParams">
          {{ button.name }}
        </a>
      }
    </div>
  </div>
</article>
